import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import React, { Suspense } from "react";
import "./App.scss";
import AuthProvider from "./modules/shared/utilities/authProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AdminRoute from "./modules/admin/adminRoute";
import EmployeeRoute from "./modules/employee/employeeRoute";

const Auth = React.lazy(() => import("./modules/authentication/authentication"));
const Layout = React.lazy(() => import("./modules/employee/layout"));
const Admin = React.lazy(() => import("./modules/admin/admin"));

const Paths = () => {
  return useRoutes([
    {
      path: "/employee/*",
      element: (
        <EmployeeRoute>
          <Layout />
        </EmployeeRoute>
      ),
    },
    {
      path: "/admin/*",
      element: (
        <AdminRoute>
          <Admin />
        </AdminRoute>
      ),
    },
    {
      path: "*",
      element: <Auth />,
    },
  ]);
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Suspense fallback={<div>Loading...</div>}>
          <Paths />
          <ToastContainer position="top-right" autoClose={3000} />
        </Suspense>
      </AuthProvider>
    </Router>
  );
}

export default App;
